// @ts-nocheck

/**
 * * `user` - user
 * `assistant` - assistant
 */
export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoleEnum = {
  user: "user",
  assistant: "assistant",
} as const;
